var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77778 17.2222H6.04444L14.7333 8.53333L13.4667 7.26667L4.77778 15.9556V17.2222ZM3.88889 19C3.63704 19 3.42593 18.9148 3.25556 18.7444C3.08519 18.5741 3 18.363 3 18.1111V15.9556C3 15.7185 3.04444 15.4926 3.13333 15.2778C3.22222 15.063 3.34815 14.8741 3.51111 14.7111L14.7333 3.51111C14.9111 3.34815 15.1074 3.22222 15.3222 3.13333C15.537 3.04444 15.763 3 16 3C16.237 3 16.4667 3.04444 16.6889 3.13333C16.9111 3.22222 17.1037 3.35556 17.2667 3.53333L18.4889 4.77778C18.6667 4.94074 18.7963 5.13333 18.8778 5.35556C18.9593 5.57778 19 5.8 19 6.02222C19 6.25926 18.9593 6.48519 18.8778 6.7C18.7963 6.91481 18.6667 7.11111 18.4889 7.28889L7.28889 18.4889C7.12593 18.6519 6.93704 18.7778 6.72222 18.8667C6.50741 18.9556 6.28148 19 6.04444 19H3.88889ZM14.0889 7.91111L13.4667 7.26667L14.7333 8.53333L14.0889 7.91111Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAdmin);
export default __webpack_public_path__ + "static/media/edit_admin.31a2409c3ff12e7c7cf45a3d8937bc16.svg";
export { ForwardRef as ReactComponent };